if (!customElements.get('title-desc-image-swiper')) {
    class TitleDescImageSwiper extends HTMLElement {
        constructor() {
            super();
            this.swiper = this.querySelector('.swiper');
            this.mySwiper = null;
        }

        connectedCallback() {
            const scrollBar = this.querySelector('.swiper-scrollbar');
            const prevButton = this.querySelector('.swiper-button-prev');
            const nextButton = this.querySelector('.swiper-button-next');
            this.mySwiper = new Swiper(this.swiper, {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 25,
                scrollbar: {
                    el: scrollBar || null,
                    draggable: true,
                },
                navigation: {
                    nextEl: nextButton || null,
                    prevEl: prevButton || null,
                },
                breakpoints: {
                    320: {
                        slidesPerView: 2.5,
                        slidesPerGroup: 1,
                        spaceBetween: 5,
                    },
                    591: {
                        slidesPerView: 2.5,
                        slidesPerGroup: 1,
                        spaceBetween: 10,
                    },
                    1001: {
                        slidesPerView: 3,
                        spaceBetween: 25,
                    }
                }
            })
        }
    }

    customElements.define('title-desc-image-swiper', TitleDescImageSwiper);
}
